import React, { Component } from 'react';
import './hsiMain.css';
import TableRow from './hsiTableRow/hsiTableRow.js';
import {API} from 'aws-amplify';

class HsiMain extends Component {

  state = {
    domains: [],
    ExclusiveStartKey: undefined,
    lastScores: this.props.chosenScores
  };

    mounted = false;

    componentDidMount() {

      this.mounted = true;

      setTimeout(() => {
        this.listDomains()
        .then(res => {
          this.setState({
            domains: [...this.state.domains, ...res.newDomains],
            ExclusiveStartKey: res.ExclusiveStartKey
          });
        });
      }, 0);

    };

    componentDidUpdate() {

      //score update
      if (this.props.chosenScores !== this.state.lastScores) {
        this.listDomains(true)
        .then(res => {
          this.setState({
            domains: [...res.newDomains],
            ExclusiveStartKey: res.ExclusiveStartKey,
            lastScores: this.props.chosenScores
          });
        });
      }

      if (!this.state.domains[(this.props.page - 1) * 100] && this.state.ExclusiveStartKey) {
        this.listDomains()
        .then(res => {
          this.setState({
            domains: [...this.state.domains, ...res.newDomains],
            ExclusiveStartKey: res.ExclusiveStartKey,
            lastScores: this.props.chosenScores
          });
        });
      }

    }

    componentWillUnmount() {
      this.mounted = false;
    }

    listDomains = overwrite => {

      const ExclusiveStartKey = overwrite ? undefined : JSON.stringify(this.state.ExclusiveStartKey);

      return API.get('HSI', '/queryscore', {queryStringParameters: {score: this.props.chosenScores, limit: 100, ExclusiveStartKey}})
      .then(res => {
        return {
          newDomains: [...res.Items],
          ExclusiveStartKey: res.LastEvaluatedKey
        };
      })
      .catch(err => {
        console.log(err);
      });
    }

    endOfResults = () => {
      console.log('END OF RESULTS');
    }

    render() {

      const {page} = this.props;

      return (
        <div className="HsiMainPage">
          <table className="HsiTable">
            <thead>
              <tr>
                <th>Global Rank</th>
                <th>Domain</th>
                <th>Hybris Score</th>
                <th>Confirm Hybris</th>
                <th>'sp-acc'</th>
                <th>'sp-mediassysmaster'</th>
                <th>'sp-acc.config'</th>
                <th>'sp-uidesktoptheme'</th>
                <th>'sp-yCmsComponent'</th>
                <th>'sp-mobiletheme'</th>
                <th>'sp-yCmsContentSlot'</th>
                <th>'sp-responsivetheme'</th>
                <th>'sp-commonjs'</th>
                <th>'sp-desktoptheme'</th>
                <th>'sp-hybris'</th>
                <th>'li-c'</th>
                <th>'li-p'</th>
                <th>'ur-smartedit'</th>
                <th>'ur-backoffice'</th>
                <th>'ur-hmc'</th>
                <th>'ur-productcockpit'</th>
                <th>'ur-hac'</th>
                <th>'ur-cmscockpit'</th>
              </tr>
            </thead>
            <tbody>
              {this.state.domains.slice((page - 1) * 100, (page * 100) - 1).map(domain => {
                return <TableRow key={domain.GlobalRank} domain={domain}/>;
              })}
            </tbody>
          </table>
        </div>
      );

    };

};

export default HsiMain;


// WEBPACK FOOTER //
// ./src/components/content/hybrisSiteIdentifier/hsiMain/hsiMain.js